import { render, staticRenderFns } from "./Effects.vue?vue&type=template&id=747bc4fb&"
import script from "./Effects.vue?vue&type=script&lang=js&"
export * from "./Effects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports